import React from 'react'
import { useForm } from 'react-hook-form'
import { Dialog, GridHookForm } from 'vnetwork-ui'
import type { NoteDialogProps } from './career-path-types'

const NoteDialog: React.FC<NoteDialogProps> = ({
    open,
    onClose,
    isLoading,
    onSubmit,
    t,
}) => {
    const formControl = useForm({
        defaultValues: { note_content: '' },
    })

    React.useEffect(() => {
        if (open) formControl.reset({ note_content: '' })
    }, [open, formControl])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={t('career_path.add_note')}
            closeOnClick
        >
            <GridHookForm
                formControl={formControl}
                onSubmit={onSubmit}
                className="grid grid-cols-1 gap-4"
                data={[
                    {
                        formItemProps: {
                            name: 'note_content',
                            label: t('career_path.note'),
                            type: 'textarea',
                            placeholder: t('career_path.note'),
                        },
                        className: 'col-span-1',
                    },
                ]}
                actions={[
                    {
                        title: t('cancel'),
                        type: 'button',
                        variant: 'outline',
                        handler: onClose,
                    },
                    {
                        title: t('save'),
                        type: 'submit',
                        variant: 'default',
                        loading: isLoading,
                        disabled: isLoading,
                    },
                ]}
            />
        </Dialog>
    )
}

export default NoteDialog
